export interface OrderPassword {
  provisionalPassword: string;
  checkoutPassword: string;
  typePassword: TypePassword;
  }

 export enum TypePassword {
    LOCKER = "LOCKER",
    USER = "USER"
  }